module.exports = __webpack_public_path__ + "static/media/LoadSURA.82bb9aca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sura/LoadSURA.svg
// module id = 616
// module chunks = 16